import { ECheckServiceStatus, ICheckoutInfoState } from './types';

export const defaultAutoProlongInfo = {
  isChecked: true,
  isAvailable: false,
  hintText: '',
  tooltipText: '',
};

export const defaultWriteOffInfo = {
  amount: 0,
  period: '',
};

export const defaultState: ICheckoutInfoState = {
  status: ECheckServiceStatus.initial,
  errorCode: null,
  isPurchaseAvailable: false,
  isInsufficientFunds: false,
  submitText: 'Разместить',
  servicesUnavailableMessage: null,
  autoProlongInfo: defaultAutoProlongInfo,
  writeOffInfo: defaultWriteOffInfo,
  writeOffWithoutDiscountInfo: null,
};
